import { render, staticRenderFns } from "./providersReport.vue?vue&type=template&id=5846c933&"
import script from "./providersReport.vue?vue&type=script&lang=js&"
export * from "./providersReport.vue?vue&type=script&lang=js&"
import style0 from "./providersReport.vue?vue&type=style&index=0&id=5846c933&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports